export default __webpack_public_path__ + "static/Fig 3 - Field Numbers-6a180aa48fec4aa08cfe394d9b39e5d5.pdf";